module.exports = {
	"library.navbar.sign_up": "Registrarse",
	"library.navbar.sign_in": "Iniciar sesión",
	"library.navbar.sign_out": "Cerrar sesión",
	"library.navbar.help": "Ayuda",
	"library.navbar.search_for_events": "Buscar eventos",
	"library.navbar.enter_location": "Introduce una ubicación",
	"library.navbar.find_events": "Encontrar eventos",
	"library.navbar.create_event": "Crear evento",
	"library.navbar.host_events": "Organizar eventos",
	"library.navbar.dashboard": "Panel de Control",
	"library.navbar.my_events": "Mis eventos",
	"library.navbar.my_tickets": "Mis entradas",
	"library.navbar.admin_panel": "Panel de administración",
	"library.navbar.profile": "Perfil",
	"library.navbar.messages": "Mensajes",
	"library.navbar.settings": "Configuración",
	"library.navbar.search_cities": "Buscar ciudades",
	"library.navbar.help_center": "Centro de ayuda",
	"library.navbar.cant_find_tickets": "¿Dónde están mis entradas?",
	"library.navbar.contact_organizer": "Contactar con el organizador del evento",
	"library.navbar.can_refund": "¿Puedo obtener un reembolso?"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/translations/es.json
// module id = 1511
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16